import React from "react";
import BottomSheet from "../BottomSheet";
import { Share2, Trash2, UploadCloud } from "lucide-react";
import { sendMessageToParent } from "src/helpers/common";
import * as recordActions from "src/redux/slices/recordsSlice";
import { useAppDispatch } from "src/redux/hooks";
import { toast } from "sonner";
import { POST_MESSAGE_EVENTS } from "src/constants/common";

interface MoreOptionsBottomSheetProps {
  showBottomSheet: boolean;
  setShowBottomSheet: (show: boolean) => void;
  record?: any;
  showUploadAgain?: boolean;
  onUploadAgainClick?: () => void;
  onDeleteSuccess?: () => void;
}

const MoreOptionsBottomSheet: React.FC<MoreOptionsBottomSheetProps> =
  React.memo(
    ({
      showBottomSheet,
      setShowBottomSheet,
      record,
      showUploadAgain = false,
      onUploadAgainClick,
      onDeleteSuccess,
    }) => {
      const dispatch = useAppDispatch();
      const handleShare = () => {
        const payload = {
          documentLink:
            Array.isArray(record?.document_url) &&
            record?.document_url?.length > 0
              ? record?.document_url[0]
              : record?.document_url,
          documentName: record?.title,
        };
        sendMessageToParent(POST_MESSAGE_EVENTS.SHARE_RECORD_DOCUMENT, payload);
      };

      const handleDelete = () => {
        const payload = {
          patient_records_id: record?.patient_records_id || "",
        };
        new Promise((resolve, reject) => {
          dispatch(
            recordActions.deleteRecordRequest({
              payload,
              resolve,
              reject,
            })
          );
        })
          .then((res) => {
            onDeleteSuccess?.();
            toast.success("Record deleted successfully");
          })
          .catch((error) => {
            console.error("Error deleting record:", error);
            toast.error("Failed to delete record");
          });
        setShowBottomSheet(false);
      };

      return (
        <BottomSheet
          show={showBottomSheet}
          handleClose={() => setShowBottomSheet(false)}
          showCloseButton
        >
          <div className="relative w-full">
            <div className="p-4">
              <h1 className="text-lg font-semibold text-black">More Options</h1>
            </div>
            <div className="flex flex-col">
              <div
                className="flex items-center gap-2 border-t border-gray-300 px-4 py-3 text-gray-700 cursor-pointer"
                onClick={handleShare}
              >
                <div className="p-2 rounded-full bg-[var(--icon-bg-primary)] text-[var(--app-primary)]">
                  <Share2 className="w-4 h-4" />
                </div>
                <span className="text-base">Share Record</span>
              </div>
              <div
                className="flex items-center gap-2 border-t border-gray-300 px-4 py-3 text-gray-700 cursor-pointer"
                onClick={handleDelete}
              >
                <div className="p-2 rounded-full bg-[var(--icon-bg-primary)] text-[var(--app-primary)]">
                  <Trash2 className="w-4 h-4" />
                </div>
                <span className="text-base">Delete Record</span>
              </div>
              {/* {showUploadAgain && (
                <div
                  className="flex items-center gap-2 border-t border-gray-300 px-4 py-3 text-gray-700 cursor-pointer"
                  onClick={onUploadAgainClick}
                >
                  <div className="p-2 rounded-full bg-[var(--icon-bg-primary)] text-[var(--app-primary)]">
                    <UploadCloud className="w-4 h-4" />
                  </div>
                  <span className="text-base">Upload Again</span>
                </div>
              )} */}
            </div>
          </div>
        </BottomSheet>
      );
    }
  );

export default MoreOptionsBottomSheet;
